import React from 'react';
import { Card, CardContent, Typography, Box } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { IHeader } from './types';

export const Header = ({ title, components, ...props }: IHeader) => {
    const { t } = useTranslation();

    return (
        <Card elevation={0} {...props}>
            <CardContent
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    padding: '10px 20px',
                }}
            >
                <Box
                    style={{ display: 'flex', flexDirection: 'column', gap: 5 }}
                >
                    <Typography variant="h5">
                        {t(`Reports.${title}`)}
                    </Typography>
                    <Typography variant="caption">
                        {t(`Reports.${title}_DESCRIPTION`)}
                    </Typography>
                </Box>
                {components?.map(
                    (component: React.ReactNode, index: number) => (
                        <Box key={index}>{component}</Box>
                    )
                )}
            </CardContent>
        </Card>
    );
};
